import React from "react";
import { Box, Typography, Chip, Paper, useMediaQuery } from "@mui/material";

const TripDetails = ({ tripDetails }: { tripDetails: any }) => {
    console.log(tripDetails,'tripDetails?.data');
    
    const tripData = tripDetails?.tripDetails;
    const isMobile = useMediaQuery("(max-width: 640px)");

    return (
        <Box className="p-6 bg-white shadow-md rounded-lg">
            <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-6`}>
                <div>
                    <div className="mt-4">
                        <Typography className="font-medium">Trip Name</Typography>
                        <Typography className="text-gray-600 mb-2">{tripData?.tripName || 'NA'}</Typography>
                    </div>

                    <div className="mt-4">
                        <Typography className="font-medium">Group</Typography>
                        <Typography className="text-gray-600 mb-2">{tripData?.groupName || 'NA'}</Typography>
                    </div>

                    <div className="mt-4">
                        <Typography className="font-medium">Status</Typography>
                        <Chip label={tripData?.tripStatus} color="success" className="mt-1 mb-2" />
                    </div>

                    <div className="mt-4">
                        <Typography className="font-medium">Journey Risk</Typography>
                        <Typography className="text-gray-600 mb-2">{tripData?.journeyRisk || 'NA'}</Typography>
                    </div>

                    <div className="mt-4">
                        <Typography className="font-medium">Verification</Typography>
                        <Typography className="text-gray-600 mb-2">Approver’s Name: {tripData?.approverName || 'NA'}</Typography>
                    </div>
                </div>

                <div>
                    <div className="mt-4">
                        <Typography className="font-medium">Tag</Typography>
                        <Chip label={tripData?.tag} className="mt-1 mb-2" />
                    </div>

                    <div className="mt-4">
                        <Typography className="font-medium">Vendor</Typography>
                        <Typography className="text-gray-600 mb-2">{tripData?.vendorName || 'NA'}</Typography>
                    </div>

                    <div className="mt-4">
                        <Typography className="font-medium">Current State</Typography>
                        <Typography className="text-gray-600 mb-2">{tripData?.currentState || 'NA'}</Typography>
                    </div>

                    <div className="mt-4">
                        <Typography className="font-medium">Current Fuel Level</Typography>
                        <Typography className="text-gray-600 mb-2">{tripData?.currentFuelLevel || 'NA'}</Typography>
                    </div>
                </div>
            </div>

            {/* Comments Section */}
            <Paper className="p-4 mt-6 bg-gray-100 rounded-lg">
                <div className="mt-4">
                    <Typography className="font-medium">Comments</Typography>
                    <Typography className="text-gray-600 mb-2">{tripData?.comments || 'NA'}</Typography>
                </div>
            </Paper>
        </Box>
    );
};

export default TripDetails;
